// extracted by mini-css-extract-plugin
module.exports = {"actions":"provider-actions_actions__ixYRc","status":"provider-actions_status__3BApm"};